module.exports = __webpack_public_path__ + "static/media/sl_risk_score_trend_down.f4244378.svg";